import React, { PropTypes } from "react";
import {Field, reduxForm} from "redux-form";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import axios from "axios";
import Constants from "../../../classes/constants";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import {TextField} from "redux-form-material-ui";
import Checkbox from "material-ui/Checkbox";

class CtcSplitHome extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeCtc = this.handleChangeCtc.bind(this);
        this.handleShowSplitCtc = this.handleShowSplitCtc.bind(this);
        this.handleShowSplitCtcChange = this.handleShowSplitCtcChange.bind(this);
        this.handlePerformanceBonusChange = this.handlePerformanceBonusChange.bind(this);
        this.changeBonusPercentage = this.changeBonusPercentage.bind(this);
        this.handleChangeFlag = this.handleChangeFlag.bind(this);
        this.state = { ctc: 0, bonusPercentage: 0, stateVal:'', skillLevel:'', empGender: '', conveyanceFlag:1, medicalFlag:1,
         ltaFlag: 1, booksAndPeriodicalsReimbursementFlag: 1, statutoryBonusFlag: 1, petrolReimbursementFlag: 1,
         driverSalaryReimbursementFlag: 1, performanceBonusFlag : 0, basic:0, hra:0,
        cityCompensatoryAllowance:0, conveyance:0, medical:0, lta:0, booksAndPeriodicalsReimbursement:0,
        statutoryBonus:0, petrolReimbursement:0, driverSalaryReimbursement:0, grossSalary:0, employersContributionToPF:0,
        employersContributionToESIC:0, fixedCTC:0, performanceBonus:0, totalCTC:0, employeeContributionToPF:0,
        employeeContributionToESIC:0, professionTax:0, netPay:0, allStates: [], skillLevels: [],
            ctcSplitDetails: {
                "0": {
                    stateValue: "Select a state",
                    skillLevelValue: "Select a skill level"
                }
            }
        };
    }

    handleChangeFlag(){
      var conveyance  = this.state.conveyance;
      if(conveyance == 0){
        this.setState({conveyanceFlag: 0});
      }
      var medical = this.state.medical;
      if(medical == 0){
        this.setState({medicalFlag: 0});
      }
      var lta = this.state.lta;
      if(lta == 0){
        this.setState({ltaFlag: 0});
      }
      var booksAndPeriodicalsReimbursement = this.state.booksAndPeriodicalsReimbursement;
      if(booksAndPeriodicalsReimbursement == 0){
        this.setState({booksAndPeriodicalsReimbursementFlag: 0});
      }
      var statutoryBonus = this.state.statutoryBonus;
      if(statutoryBonus == 0){
         this.setState({statutoryBonusFlag: 0});
      }
      var petrolReimbursement = this.state.petrolReimbursement;
      if(petrolReimbursement == 0){
        this.setState({petrolReimbursementFlag: 0});
      }
      var driverSalaryReimbursement = this.state.driverSalaryReimbursement;
      if(driverSalaryReimbursement == 0){
        this.setState({driverSalaryReimbursementFlag: 0});
      }
    }

    handlePerformanceBonusChange(){
      var performanceBonusFlag = this.state.performanceBonusFlag;
      if(performanceBonusFlag == 1){
         $("#bonusPercentage").css("display", "block");
      }else{
         $("#bonusPercentage").css("display", "none");
        this.handleShowSplitCtcChange();
      }
    }

    handleShowSplitCtcChange(){
      var stateValue = this.state.stateVal;
      var skillLevel = this.state.skillLevel;
      var empGender = this.state.empGender;
      var ctc = this.state.ctc;
      var conveyanceFlag  = this.state.conveyanceFlag;
      var medicalFlag = this.state.medicalFlag;
      var ltaFlag = this.state.ltaFlag;
      var booksAndPeriodicalsReimbursementFlag = this.state.booksAndPeriodicalsReimbursementFlag;
      var statutoryBonusFlag = this.state.statutoryBonusFlag;
      var petrolReimbursementFlag = this.state.petrolReimbursementFlag;
      var driverSalaryReimbursementFlag = this.state.driverSalaryReimbursementFlag;
      var performanceBonusFlag = this.state.performanceBonusFlag;
      var bonusPercentage = this.state.bonusPercentage;

      let apiUrl = process.env.REQ_URL +'/splitCtc/getSplitCtcDetails';
      axios.post(apiUrl, {data: {
        stateValue : stateValue, skillLevel : skillLevel, empGender : empGender, ctc : ctc,
        conveyanceFlag : conveyanceFlag, medicalFlag : medicalFlag, ltaFlag : ltaFlag,
        booksAndPeriodicalsReimbursementFlag : booksAndPeriodicalsReimbursementFlag, statutoryBonusFlag : statutoryBonusFlag,
        petrolReimbursementFlag: petrolReimbursementFlag, driverSalaryReimbursementFlag: driverSalaryReimbursementFlag,
        performanceBonusFlag : performanceBonusFlag, bonusPercentage : bonusPercentage
      }}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        $("#ctcDetails").css("display", "block");
        $("#optionFilter").css("display", "block");
        var ctcDetails = response.data.data;
        this.setState({basic: ctcDetails.basic, hra:ctcDetails.hra,
          cityCompensatoryAllowance:ctcDetails.cityCompensatoryAllowance, conveyance:ctcDetails.conveyance,
          medical:ctcDetails.medical, lta:ctcDetails.lta, booksAndPeriodicalsReimbursement:ctcDetails.booksAndPeriodicalsReimbursement,
          statutoryBonus:ctcDetails.statutoryBonus, petrolReimbursement:ctcDetails.petrolReimbursement,
          driverSalaryReimbursement:ctcDetails.driverSalaryReimbursement,
          grossSalary:ctcDetails.grossSalary, employersContributionToPF:ctcDetails.employersContributionToPF,
          employersContributionToESIC:ctcDetails.employersContributionToESIC, fixedCTC:ctcDetails.fixedCTC,
          performanceBonus:ctcDetails.performanceBonus, totalCTC:ctcDetails.totalCTC,
          employeeContributionToPF:ctcDetails.employeeContributionToPF,
          employeeContributionToESIC:ctcDetails.employeeContributionToESIC, professionTax:ctcDetails.professionTax,
          netPay:ctcDetails.netPay
        },()=>{
          this.handleChangeFlag();
        });
      }).catch((err)=> {
        console.log("error on split ctc");
      });
    }

    changeBonusPercentage(event){
      this.setState({ bonusPercentage: event.target.value }, () => {
        this.handleShowSplitCtcChange();
      });
    }

    handleShowSplitCtc (event) {
      event.preventDefault();
      var submitFlag = 1;
      var stateValue = this.state.stateVal;
      if(stateValue == 0 || stateValue == ''|| stateValue == null){
        submitFlag = 0;
        alert('Please select state');
        return false;
      }
      if(submitFlag){
        var skillLevel = this.state.skillLevel;
        if(skillLevel == 0 || skillLevel == ''|| skillLevel == null){
          submitFlag = 0;
          alert('Please select skill level');
          return false;
        }
      }
      if(submitFlag){
        var empGender = this.state.empGender;
        if(empGender == '' || empGender == null){
          submitFlag = 0;
          alert('Please select gender');
          return false;
        }
      }
      if(submitFlag){
        var ctc = this.state.ctc;
        if(ctc == 0 || ctc == '' || ctc == null){
          submitFlag = 0;
          alert('Please enter CTC');
          return false;
        }
      }
      if(submitFlag){
        this.handleShowSplitCtcChange();
      }
    }

    handleChangeCtc(event) {
      this.setState({ctc: event.target.value});
    }

  componentDidMount() {
      let splitCTC = this.state.ctcSplitDetails[0];
      splitCTC.stateValue = "";
      splitCTC.skillLevelValue = "";


      axios.get(
        process.env.REQ_URL +"/splitCtc/getStates",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ allStates : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /splitCtc/getStates" + error
        );
      });

      axios.get(
        process.env.REQ_URL +"/splitCtc/getSkillLevel",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ skillLevels : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /splitCtc/getSkillLevel" + error
        );
      });
  }

  refresh() {
      let splitCTC = this.state.ctcSplitDetails[0];
      splitCTC.stateValue = "";
      splitCTC.skillLevelValue = "";

      axios.get(
        process.env.REQ_URL +"/splitCtc/getStates",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ allStates : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /splitCtc/getStates" + error
        );
      });

      axios.get(
        process.env.REQ_URL +"/splitCtc/getSkillLevel",
        {
          withCredentials: true,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }
      ).then(response => {
        this.setState({ skillLevels : response.data.data });
      }).catch(error => {
        console.log(
          "error while calling api /splitCtc/getSkillLevel" + error
        );
      });
  }

  render() {
    let conveyance;
    if(this.state.conveyanceFlag>0){
      conveyance = <tr><td>Conveyance</td><td>{this.state.conveyance}</td></tr>
    }
    let medical;
    if(this.state.medicalFlag>0){
      medical = <tr><td>Medical</td><td>{this.state.medical}</td></tr>
    }
    let lta;
    if(this.state.ltaFlag>0){
      lta = <tr><td>LTA</td><td>{this.state.lta}</td></tr>
    }
    let booksAndPeriodicalsReimbursement;
    if(this.state.booksAndPeriodicalsReimbursementFlag>0){
      booksAndPeriodicalsReimbursement = <tr><td>Books And Periodicals Reimbursement</td><td>{this.state.booksAndPeriodicalsReimbursement}</td></tr>
    }
    let statutoryBonus;
    if(this.state.statutoryBonusFlag>0){
      statutoryBonus = <tr><td>Statutory Bonus</td><td>{this.state.statutoryBonus}</td></tr>
    }
    let petrolReimbursement;
    if(this.state.petrolReimbursementFlag>0){
      petrolReimbursement = <tr><td>Petrol Reimbursement</td><td>{this.state.petrolReimbursement}</td></tr>
    }
    let driverSalaryReimbursement;
    if(this.state.driverSalaryReimbursementFlag>0){
      driverSalaryReimbursement = <tr><td>Driver Salary Reimbursement</td><td>{this.state.driverSalaryReimbursement}</td></tr>
    }
    let performanceBonus;
    if(this.state.performanceBonusFlag>0){
      performanceBonus = <tr><td>Performance Bonus</td><td>{this.state.performanceBonus}</td></tr>
    }
    return (
      <form name="ctcDetails" onSubmit={this.handleShowSplitCtc} id="ctcSplit">
        <div className="responsive">
        <table className="table" id = "ctcSplitSelect" cellpadding="0" cellspacing="0" border="0">
          {Object.keys(this.state.ctcSplitDetails).map(idx => {
            const item = this.state.ctcSplitDetails[idx];
            return (
              <tr id={idx} key={idx}>
                <td width="23%">
                  <div className="form-group">
                    <SelectField
                      labelStyle={{ color: "#1E88E5" }}
                      style={{ width: "80%", fontSize: "12px"}}
                      defaultValue="Select a state"
                      id = "state"
                      value={
                        this.state.ctcSplitDetails[idx] &&
                        this.state.ctcSplitDetails[idx].stateValue
                      }
                      onChange={(option, data, stateValue) => {
                        const stateData = this.state.ctcSplitDetails[idx];
                        stateData.stateValue = stateValue;
                        this.setState({
                            stateVal : stateValue,
                            ctcSplitDetails : Object.assign( this.state.ctcSplitDetails, {[idx]: stateData })
                        });
                      }}
                    >
                    <MenuItem value="" primaryText="Select a state" />
                    { this.state.allStates.map((stateDetails) => {
                      return (
                        <MenuItem value={stateDetails.id} primaryText={stateDetails.stateName}/>
                      );
                    })}
                    </SelectField>
                  </div>
                </td>

                <td width="23%">
                  <div className="form-group">
                    <SelectField
                      labelStyle={{ color: "#1E88E5" }}
                      style={{ width: "80%", fontSize: "12px"}}
                      defaultValue="Select a skill level"
                      id = "skillLevel"
                      value={
                        this.state.ctcSplitDetails[idx] &&
                        this.state.ctcSplitDetails[idx].skillLevelValue
                      }
                      onChange={(option, data, skill) => {
                        const skillData = this.state.ctcSplitDetails[idx];
                        skillData.skillLevelValue = skill;
                        this.setState({
                          optional: false,
                          show: true,
                          skillLevel : skill,
                          ctcSplitDetails : Object.assign(this.state.ctcSplitDetails, {[idx]: skillData})
                        });
                      }}
                    >
                    <MenuItem value="" primaryText="Select a skill level" />
                    {this.state.skillLevels.map((skillLevel, index) => {
                        return (
                          <MenuItem value={skillLevel.id} primaryText={skillLevel.skillLevelName}/>
                        );
                      })
                    }
                    </SelectField>
                  </div>
                </td>

                <td style={{width: '200px'}}>
                  <div className="form-group">
                    <SelectField labelStyle={{ color: "#1E88E5" }}
                      style={{ width: "80%", fontSize: "12px" }}
                      defaultValue="Select employee gender"
                      name="emp_gender" id="empGender" value = {this.state.empGender}
                      onChange={(option, data, emp_gender) => {
                        this.setState({
                          optional: false,
                          show: true,
                          empGender : emp_gender
                        });
                      }}
                    >
                      <MenuItem value='' primaryText='Select employee gender'/>
                      <MenuItem value='1' primaryText='Male'/>
                      <MenuItem value='0' primaryText='Female'/>
                    </SelectField>
                  </div>
                </td>

                <td width="5%" id = 'ctcValue' style={{ textAlign: "center" }}>
                   <Field name="ctc" id = "ctc" component={TextField} value = {this.state.ctc} placeholder="Enter CTC here" onChange = {this.handleChangeCtc}/>
                </td>
              </tr>
            );
          })}
        </table>

        <div className="cta_button">
          <input type="submit" value="Split CTC" color="primary" className="btn btn-primary" />
        </div>
        <div style={{marginTop : '10px', display: "none"}} id='optionFilter'>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.conveyanceFlag}
              style={{marginLeft: '5px'}}
              label="Conveyance"
              onCheck={()=> {
                this.setState({
                  conveyanceFlag: !this.state.conveyanceFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.medicalFlag}
              style={{marginLeft: '5px'}}
              label="Medical"
              onCheck={()=> {
                this.setState({
                  medicalFlag: !this.state.medicalFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.ltaFlag}
              style={{marginLeft: '5px'}}
              label="LTA"
              onCheck={()=> {
                this.setState({
                  ltaFlag: !this.state.ltaFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.booksAndPeriodicalsReimbursementFlag}
              style={{marginLeft: '5px'}}
              label="Books And Periodicals Reimbursement"
              onCheck={()=> {
                this.setState({
                  booksAndPeriodicalsReimbursementFlag: !this.state.booksAndPeriodicalsReimbursementFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.statutoryBonusFlag}
              style={{marginLeft: '5px'}}
              label="Statutory Bonus"
              onCheck={()=> {
                this.setState({
                  statutoryBonusFlag: !this.state.statutoryBonusFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.petrolReimbursementFlag}
              style={{marginLeft: '5px'}}
              label="Petrol Reimbursement"
              onCheck={()=> {
                this.setState({
                  petrolReimbursementFlag: !this.state.petrolReimbursementFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.driverSalaryReimbursementFlag}
              style={{marginLeft: '5px'}}
              label="Driver Salary Reimbursement"
              onCheck={()=> {
                this.setState({
                  driverSalaryReimbursementFlag: !this.state.driverSalaryReimbursementFlag
                }, () => {
                  this.handleShowSplitCtcChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" style={{display: 'inline'}}>
            <Checkbox checked={this.state.performanceBonusFlag}
              style={{marginLeft: '5px'}}
              label="Performance Bonus"
              onCheck={()=> {
                this.setState({
                  performanceBonusFlag: !this.state.performanceBonusFlag
                }, () => {
                  this.handlePerformanceBonusChange();
                });
              }}
            />
          </div>
          <div className="col-md-3" id = "bonusPercentage" style={{display: 'none'}}>
            <Field name="bonusPercentage" component={TextField} value = {this.state.bonusPercentage} placeholder="Enter bonus percentage here" onChange = {this.changeBonusPercentage}/>
          </div>
          <div className="col-md-2">
            <button className="btn btn-default btn-block" onClick={()=> {
              let flag = confirm('Are you sure data is correct?');
                if (flag == true) {
                  var basic = this.state.basic;
                  var hra = this.state.hra;
                  var cityCompensatoryAllowance = this.state.cityCompensatoryAllowance;
                  var conveyance = this.state.conveyance;
                  var medical = this.state.medical;
                  var lta  = this.state.lta;
                  var booksAndPeriodicalsReimbursement = this.state.booksAndPeriodicalsReimbursement;
                  var statutoryBonus = this.state.statutoryBonus;
                  var petrolReimbursement = this.state.petrolReimbursement;
                  var driverSalaryReimbursement = this.state.driverSalaryReimbursement;
                  var grossSalary = this.state.grossSalary;
                  var employersContributionToPF = this.state.employersContributionToPF;
                  var employersContributionToESIC = this.state.employersContributionToESIC;
                  var fixedCTC = this.state.fixedCTC;
                  var performanceBonus = this.state.performanceBonus;
                  var totalCTC = this.state.totalCTC;
                  var employeeContributionToPF = this.state.employeeContributionToPF;
                  var employeeContributionToESIC = this.state.employeeContributionToESIC;
                  var professionTax = this.state.professionTax;
                  var netPay = this.state.netPay;

                  axios.post(process.env.REQ_URL + "/splitCtc/downloadDetailsAsDoc", {data: {
                    basic : basic, hra : hra, cityCompensatoryAllowance : cityCompensatoryAllowance, conveyance : conveyance,
                    medical : medical, lta : lta, booksAndPeriodicalsReimbursement : booksAndPeriodicalsReimbursement,
                    statutoryBonus : statutoryBonus, petrolReimbursement : petrolReimbursement, driverSalaryReimbursement : driverSalaryReimbursement,
                    grossSalary : grossSalary, employersContributionToPF : employersContributionToPF, employersContributionToESIC : employersContributionToESIC,
                    fixedCTC : fixedCTC, performanceBonus : performanceBonus, totalCTC : totalCTC,
                    employeeContributionToPF : employeeContributionToPF, employeeContributionToESIC : employeeContributionToPF,
                    professionTax : professionTax, netPay : netPay
                  }}, {withCredentials: true , responseType: 'blob', headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', 'CTC_Details.doc');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                  }).catch((err)=> {
                    "error while calling api /splitCtc/downloadDetailsAsDoc" + err
                  });
                }
            }}>Download As Doc
            </button>
          </div>
          <div className="col-md-2">
                      <button className="btn btn-default btn-block" onClick={()=> {
                        let flag = confirm('Are you sure data is correct?');
                          if (flag == true) {
                            var basic = this.state.basic;
                            var hra = this.state.hra;
                            var cityCompensatoryAllowance = this.state.cityCompensatoryAllowance;
                            var conveyance = this.state.conveyance;
                            var medical = this.state.medical;
                            var lta  = this.state.lta;
                            var booksAndPeriodicalsReimbursement = this.state.booksAndPeriodicalsReimbursement;
                            var statutoryBonus = this.state.statutoryBonus;
                            var petrolReimbursement = this.state.petrolReimbursement;
                            var driverSalaryReimbursement = this.state.driverSalaryReimbursement;
                            var grossSalary = this.state.grossSalary;
                            var employersContributionToPF = this.state.employersContributionToPF;
                            var employersContributionToESIC = this.state.employersContributionToESIC;
                            var fixedCTC = this.state.fixedCTC;
                            var performanceBonus = this.state.performanceBonus;
                            var totalCTC = this.state.totalCTC;
                            var employeeContributionToPF = this.state.employeeContributionToPF;
                            var employeeContributionToESIC = this.state.employeeContributionToESIC;
                            var professionTax = this.state.professionTax;
                            var netPay = this.state.netPay;

                            axios.post(process.env.REQ_URL + "/splitCtc/downloadDetailsAsPdf", {data: {
                              basic : basic, hra : hra, cityCompensatoryAllowance : cityCompensatoryAllowance, conveyance : conveyance,
                              medical : medical, lta : lta, booksAndPeriodicalsReimbursement : booksAndPeriodicalsReimbursement,
                              statutoryBonus : statutoryBonus, petrolReimbursement : petrolReimbursement, driverSalaryReimbursement : driverSalaryReimbursement,
                              grossSalary : grossSalary, employersContributionToPF : employersContributionToPF, employersContributionToESIC : employersContributionToESIC,
                              fixedCTC : fixedCTC, performanceBonus : performanceBonus, totalCTC : totalCTC,
                              employeeContributionToPF : employeeContributionToPF, employeeContributionToESIC : employeeContributionToPF,
                              professionTax : professionTax, netPay : netPay
                            }}, {withCredentials: true , responseType: 'blob', headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                              const link = document.createElement('a');
                              link.href = window.URL.createObjectURL(new Blob([response.data]));
                              link.setAttribute('download', 'CTC_Details.pdf');
                              document.body.appendChild(link);
                              link.click();
                              link.remove();
                            }).catch((err)=> {
                              "error while calling api /splitCtc/downloadDetailsAsPdf" + err
                            });
                          }
                      }}>Download As PDF
                      </button>
                    </div>
        </div>
        <table className="table" cellpadding="0" cellspacing="0" border="1" style={{ display: "none"}} id="ctcDetails">
        <tr>
          <td width = '100%'>Basic</td>
          <td width = '100%'> {this.state.basic} </td>
        </tr>
        <tr>
          <td>HRA</td>
          <td>{this.state.hra}</td>
        </tr>
        <tr>
          <td>City Compensatory Allowance</td>
          <td>{this.state.cityCompensatoryAllowance}</td>
        </tr>
        {conveyance}
        {medical}
        {lta}
        {booksAndPeriodicalsReimbursement}
        {statutoryBonus}
        {petrolReimbursement}
        {driverSalaryReimbursement}
        <tr>
          <td><b>Gross Salary</b></td>
          <td>{this.state.grossSalary}</td>
        </tr>
        <tr>
          <td>Add: Employers contribution to PF</td>
          <td>{this.state.employersContributionToPF}</td>
        </tr>
        <tr>
          <td>Add: Employers contribution to ESIC</td>
          <td>{this.state.employersContributionToESIC}</td>
        </tr>
        <tr>
          <td><b>Fixed CTC</b></td>
          <td>{this.state.fixedCTC}</td>
        </tr>
        {performanceBonus}
        <tr>
          <td><b>Total CTC </b></td>
          <td>{this.state.totalCTC}</td>
        </tr>
        <tr>
          <td>Ded: Employee contribution to PF</td>
          <td>{this.state.employeeContributionToPF}</td>
        </tr>
        <tr>
          <td>Ded: Employee contribution to ESIC</td>
          <td>{this.state.employeeContributionToESIC}</td>
        </tr>
        <tr>
          <td>Ded: Profession Tax</td>
          <td>{this.state.professionTax}</td>
        </tr>
        <tr>
          <td><b>Net Pay </b></td>
          <td>{this.state.netPay}</td>
        </tr>
        </table>
      </div>
    </form>
    );
  }
}

CtcSplitHome.proptypes = {};

export default reduxForm({
  form: 'ctcSplitHome',
})(CtcSplitHome);



/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/ctcSplit/CtcSplitHome.js
 **/